"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AsyncModule = AsyncModule;
exports.default = AsyncComponent;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _spinner = _interopRequireDefault(require("../other/spinner"));
var _merchButton = require("@site/pattern-library-core/merch-button");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react/jsx-pascal-case */

const RetryButtonContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "RetryButtonContainer",
  class: "pl-r665kbl"
});
function AsyncComponent({
  sitecoreID,
  component,
  callback,
  active,
  retryText
}) {
  const {
    data,
    isLoading,
    error,
    setRetry
  } = (0, _patternLibraryUtils.useAsyncSitecoreData)(sitecoreID, callback, active);
  const Component = component;
  const ready = !!data && !!Component && !error;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isLoading && /*#__PURE__*/_react.default.createElement(_spinner.default, null), ready && /*#__PURE__*/_react.default.createElement(Component, data), error && /*#__PURE__*/_react.default.createElement(RetryButtonContainer, null, /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButton, {
    text: retryText,
    onClick: () => setRetry(true),
    "data-cy": "retry-button"
  })));
}
AsyncComponent.propTypes = {
  sitecoreID: _propTypes.default.string,
  component: _propTypes.default.elementType,
  callback: _propTypes.default.func,
  active: _propTypes.default.bool,
  retryText: _propTypes.default.string
};
function AsyncModule({
  moduleLoader,
  ...rest
}) {
  const [component, setComponent] = (0, _react.useState)(null);
  const loadComponentFromModule = (0, _react.useCallback)(async res => {
    const module = await moduleLoader(res.templateName);
    setComponent(module);
  }, [moduleLoader]);
  return /*#__PURE__*/_react.default.createElement(AsyncComponent, (0, _extends2.default)({
    callback: loadComponentFromModule
  }, rest, {
    component: component?.default
  }));
}
AsyncModule.propTypes = {
  moduleLoader: _propTypes.default.func,
  ...AsyncComponent.propTypes
};